'use client'

import React from 'react'
import { CMSLink } from '@/components/Link'
import RichText from '@/components/RichText'
import type { CTABlocks as CTABlocksProps } from '@/payload-types'

export const CTABlocksComponent: React.FC<CTABlocksProps> = ({
  eyebrow,
  title,
  description,
  ctaButtons,
}) => {
  if (!ctaButtons || ctaButtons.length === 0) {
    return null
  }

  return (
    <section className="w-full" aria-label="Call to action section">
      <div className="container mx-auto px-6">
        <div className="flex flex-col items-center text-center space-y-5 w-full">
          {/* Header Content - Always centered */}
          <header className="space-y-3 w-full flex flex-col items-center">
            {eyebrow && (
              <div className="flex justify-center">
                <div className="border border-primary px-4 py-2 rounded-full inline-flex items-center">
                  <span className="text-primary text-sm font-medium">{eyebrow}</span>
                </div>
              </div>
            )}

            {title && (
              <div className="text-2xl md:text-3xl lg:text-4xl font-bold leading-tight">
                <RichText data={title} enableGutter={false} enableProse={false} />
              </div>
            )}

            {description && (
              <div className="text-lg text-muted-foreground">
                <RichText data={description} enableGutter={false} enableProse={false} />
              </div>
            )}
          </header>

          {/* CTA Cards - Grid Layout */}
          <nav aria-label="Call to action cards" className="w-full">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 w-full">
              {ctaButtons.map((button: any, index: number) => {
                if (!button?.link) return null

                const { link } = button

                return (
                  <div
                    key={index}
                    className="group relative overflow-hidden rounded-xl border border-border bg-card hover:shadow-xl transition-all duration-300"
                  >
                    <CMSLink
                      {...link}
                      className="z-10 inline-flex items-center justify-center border border-primary text-primary bg-primary-foreground hover:bg-primary/90 cursor-pointer font-bold text-xl tracking-wide transition-colors duration-300 rounded-xl p-8 h-full w-full text-center"
                      aria-label={link.label || `Call to action card ${index + 1}`}
                    >
                      {link.label}
                    </CMSLink>
                  </div>
                )
              })}
            </div>
          </nav>
        </div>
      </div>
    </section>
  )
}

export default CTABlocksComponent
